var path = 'app/scripts/modules/amazon/src/applicationProviderFields/awsFields.html';
var html = "<div class=\"form-group row\">\n  <div class=\"col-sm-3 sm-label-right\">AWS Settings</div>\n  <div class=\"col-sm-9 checkbox\" style=\"margin-bottom: 0; margin-top: 5px\">\n    <label>\n      <input type=\"checkbox\"\n             ng-init=\"$ctrl.initializeApplicationField('aws.useAmiBlockDeviceMappings')\"\n             ng-model=\"$ctrl.application.providerSettings.aws.useAmiBlockDeviceMappings\"/>\n      Prefer AMI Block Device Mappings\n    </label>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/amazon/src/applicationProviderFields/awsFields.html
// module id = 1209
// module chunks = 0